exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n}\n\nsvg {\n  display: initial;\n  vertical-align: initial;\n}", ""]);

// exports
